/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { TaxationType } from '../companies/companiesClient.typings';
import { StoreType } from '../stores/storesClientTypings';

export interface CashRegisterModelShortDto {
    taxNumber: string;
    name: string;
    operatorTaxNumber: string;
}

export interface OperatorShortDto {
    companyName: string;
    companyTaxNumber: string;
}

export class UserShortDto {
    id: number;
    firstName: string;
    lastName: string;
}

export interface StoreTypeResource {
    id: number;
    name: StoreType;
}

export interface FirmwareVersionDTO {
    id: number;
    name: string;
}

export interface FiscalDriverVersionDto {
    id: number;
    name: string;
}

export interface TaxAuthorityDTO {
    id: string;
    name: string;
}

export interface TaxationTypeDTO {
    name: TaxationType;
    id: number;
}

export interface CityResource {
    id: number;
    name: string;
}

export interface RegionResource {
    id: number;
    name: string;
    code: string;
}

export interface ActivityDto {
    id: number;
    name: string; //translation key or activity in Az
}

//just for mock-data
export enum StoreMainActivity {
    TRADE = 'TRADE',
    CATERING_SERVICES = 'CATERING_SERVICES',
    OTHER_SERVICES = 'OTHER_SERVICES',
    PRODUCTION_FACILITY_NON_FOOD = 'PRODUCTION_FACILITY_NON_FOOD',
    SPORTS_LEISURE_AND_ENTERTAINMENT_SERVICES = 'SPORTS_LEISURE_AND_ENTERTAINMENT_SERVICES',
    HEALTHCARE_SERVICES = 'HEALTHCARE_SERVICES',
    HOUSEHOLD_SERVICES = 'HOUSEHOLD_SERVICES',
    PRODUCTION_FACILITY_FOOD = 'PRODUCTION_FACILITY_FOOD',
    COMMUNICATION_SERVICES = 'COMMUNICATION_SERVICES',
    TRAVEL_SERVICES = 'TRAVEL_SERVICES',
    PRODUCTION_FACILITY_BEVERAGES = 'PRODUCTION_FACILITY_BEVERAGES',
    PRODUCTION_FACILITY = 'PRODUCTION_FACILITY',
    EDUCATION_SERVICES = 'EDUCATION_SERVICES',
    TRANSPORTATION_SERVICES = 'TRANSPORTATION_SERVICES',
    FINANCIAL_SERVICES = 'FINANCIAL_SERVICES',
}

//just for mock-data
export enum StoreMiddleActivity {
    RETAIL_TRADE = 'RETAIL_TRADE',
    CAFE_RESTAURANT = 'CAFE_RESTAURANT',
    RENTAL_FACILITY = 'RENTAL_FACILITY',
    CELEBRATION_HOUSE = 'CELEBRATION_HOUSE',
    CAR_SERVICE = 'CAR_SERVICE',
    FACTORY = 'FACTORY',
    WHOLESALE_TRADE = 'WHOLESALE_TRADE',
    OFFICE = 'OFFICE',
    TICKET_SALES = 'TICKET_SALES',
    LEISURE_AND_ENTERTAINMENT_CENTER = 'LEISURE_AND_ENTERTAINMENT_CENTER',
    HOSPITAL = 'HOSPITAL',
    CULTURAL_OBJECT = 'CULTURAL_OBJECT',
    SPORTS_CENTER = 'SPORTS_CENTER',
    TAILOR = 'TAILOR',
    WAREHOUSE = 'WAREHOUSE',
    WATCH_REPAIRING = 'WATCH_REPAIRING',
    CEREMONY_HOUSE = 'CEREMONY_HOUSE',
    TELEVISION_AND_RADIO_BROADCASTING = 'TELEVISION_AND_RADIO_BROADCASTING',
    HOTEL = 'HOTEL',
    DENTISTRY = 'DENTISTRY',
    HAIRDRESSERS_AND_BEAUTY_SALONS = 'HAIRDRESSERS_AND_BEAUTY_SALONS',
    DRY_CLEANING = 'DRY_CLEANING',
    AGRICULTURE = 'AGRICULTURE',
    SHOPPING_CENTER_MARKETPLACE = 'SHOPPING_CENTER_MARKETPLACE',
    FASHION_HOUSE_ATELIER = 'FASHION_HOUSE_ATELIER',
    POULTRY_AND_LIVESTOCK_FARMING = 'POULTRY_AND_LIVESTOCK_FARMING',
    PHONE_REPAIR = 'PHONE_REPAIR',
    TEAHOUSE = 'TEAHOUSE',
    PRE_SCHOOL_EDUCATION = 'PRE_SCHOOL_EDUCATION',
    MOBILE_COMMUNICATION_CUSTOMER_SERVICE = 'MOBILE_COMMUNICATION_CUSTOMER_SERVICE',
    BUS_STATION = 'BUS_STATION',
    TRAINING_COURSES = 'TRAINING_COURSES',
    MOBILE_PHONE_REPAIR = 'MOBILE_PHONE_REPAIR',
    FURNITURE_REPAIR = 'FURNITURE_REPAIR',
    SOCIAL_ASSISTANCE = 'SOCIAL_ASSISTANCE',
    MEDICAL_HEALTH_CARE_SERVICES = 'MEDICAL_HEALTH_CARE_SERVICES',
    LOMBARD = 'LOMBARD',
    EXHIBITION_HALL = 'EXHIBITION_HALL',
    LAUNDRY = 'LAUNDRY',
    CAR_PARKING = 'CAR_PARKING',
    FREIGHT_TRANSPORTATION_OFFICE = 'FREIGHT_TRANSPORTATION_OFFICE',
    RECEPTION_POINT_FOR_METALS_AND_OTHER_WASTE = 'RECEPTION_POINT_FOR_METALS_AND_OTHER_WASTE',
    WEDDING_DRESS_RENTAL = 'WEDDING_DRESS_RENTAL',
    ANIMAL_TRAINING_AND_CARE = 'ANIMAL_TRAINING_AND_CARE',
    COMPUTER_REPAIR = 'COMPUTER_REPAIR',
    COURIER_OR_DELIVERY_SERVICE = 'COURIER_OR_DELIVERY_SERVICE',
    BOILER_REPAIR = 'BOILER_REPAIR',
    JEWELLERY_SERVICES = 'JEWELLERY_SERVICES',
    NOTARY_OFFICE_LEGAL_SERVICES = 'NOTARY_OFFICE_LEGAL_SERVICES',
    MEDICAL_CENTER = 'MEDICAL_CENTER',
    TELECOMMUNICATION_ACTIVITIES = 'TELECOMMUNICATION_ACTIVITIES',
    DECORATIVE_WORKS = 'DECORATIVE_WORKS',
    RENTAL_OF_SPORTS_AND_LEISURE_GOODS = 'RENTAL_OF_SPORTS_AND_LEISURE_GOODS',
    PHOTO_STUDIO = 'PHOTO_STUDIO',
    CLOTHING_RENTAL = 'CLOTHING_RENTAL',
    COMPUTER_SERVICES = 'COMPUTER_SERVICES',
    GLASS_WASTE_COLLECTION_POINT = 'GLASS_WASTE_COLLECTION_POINT',
    INTERNET_SUPPLY_SERVICE = 'INTERNET_SUPPLY_SERVICE',
    GAMBLING = 'GAMBLING',
    INTERNET_CLUB = 'INTERNET_CLUB',
    POST_OFFICE = 'POST_OFFICE',
    SHOE_REPAIR = 'SHOE_REPAIR',
    PHOTO_PRINTING_SHOP = 'PHOTO_PRINTING_SHOP',
    DECORATION_OF_TRAYS = 'DECORATION_OF_TRAYS',
    SANATORIUM = 'SANATORIUM',
    EYEGLASSES_REPAIR = 'EYEGLASSES_REPAIR',
    TOURIST_CAMPS_AND_RESORTS = 'TOURIST_CAMPS_AND_RESORTS',
    CURRENCY_EXCHANGE_POINT = 'CURRENCY_EXCHANGE_POINT',
    VIDEO_COPYING_SERVICE = 'VIDEO_COPYING_SERVICE',
    REPAIR_AND_PAINTING_OF_METAL_PRODUCTS = 'REPAIR_AND_PAINTING_OF_METAL_PRODUCTS',
    DORMITORY = 'DORMITORY',
    BICYCLE_REPAIR = 'BICYCLE_REPAIR',
    CLEANING_SERVICE = 'CLEANING_SERVICE',
    PASSENGER_TRANSPORTATION_OFFICE = 'PASSENGER_TRANSPORTATION_OFFICE',
    KEY_MAKING_AND_REPAIR_SERVICE = 'KEY_MAKING_AND_REPAIR_SERVICE',
    VEHICLE_AND_EQUIPMENT_REPAIR = 'VEHICLE_AND_EQUIPMENT_REPAIR',
    RENTAL_OF_VIDEO_TAPES_AND_DISCS = 'RENTAL_OF_VIDEO_TAPES_AND_DISCS',
    AIRPORT = 'AIRPORT',
    MANAGEMENT_OF_APARTMENT_BUILDINGS = 'MANAGEMENT_OF_APARTMENT_BUILDINGS',
    CLOTHING_REPAIR = 'CLOTHING_REPAIR',
    RESORT_AREA = 'RESORT_AREA',
    REPAIR_OF_HOUSEHOLD_APPLIANCES = 'REPAIR_OF_HOUSEHOLD_APPLIANCES',
    TOILET = 'TOILET',
    CARPET_CLEANING = 'CARPET_CLEANING',
    WEDDING_CAR_DECORATION = 'WEDDING_CAR_DECORATION',
    TURNER = 'TURNER',
    HIGHER_EDUCATION = 'HIGHER_EDUCATION',
    POTTERY_TINWORK_AND_DISHWARE_PRODUCTION = 'POTTERY_TINWORK_AND_DISHWARE_PRODUCTION',
    PUMP_REPAIR = 'PUMP_REPAIR',
    SCHOOL_VOCATIONAL_COLLEGE = 'SCHOOL_VOCATIONAL_COLLEGE',
    TINWORKER = 'TINWORKER',
    FINE_ARTS = 'FINE_ARTS',
    SHIP_REPAIR_AND_MAINTENANCE = 'SHIP_REPAIR_AND_MAINTENANCE',
}

//just for mock-data (not complete)
export enum StoreLowerActivity {
    SELLING_ALCOHOLIC_BEVERAGES = 'SELLING_ALCOHOLIC_BEVERAGES',
    SELLING_WATCHES = 'SELLING_WATCHES',
    RESTAURANT = 'RESTAURANT',
    RENTAL_FACILITY = 'RENTAL_FACILITY',
    FUEL_SELLING = 'FUEL_SELLING',
    SELLING_PETROLEUM_PRODUCTS = 'SELLING_PETROLEUM_PRODUCTS',
    FUEL_FILLING_POINTS = 'FUEL_FILLING_POINTS',
    CELEBRATION_HOUSE = 'CELEBRATION_HOUSE',
    FOODS_SELLING = 'FOODS_SELLING',
    MARKET_NETWORK_FOOD = 'MARKET_NETWORK_FOOD',
    CAR_SERVICE = 'CAR_SERVICE',
    SELLING_WOMEN_CLOTHING = 'SELLING_WOMEN_CLOTHING',
    FURNITURE_MANUFACTURING = 'FURNITURE_MANUFACTURING',
    GAS_FILLING_POINTS = 'GAS_FILLING_POINTS',
    SELLING_TOBACCO_PRODUCTS = 'SELLING_TOBACCO_PRODUCTS',
    SECURITY_SERVICE = 'SECURITY_SERVICE',
    SELLING_BIJOUTERIE_AND_ACCESSORIES = 'SELLING_BIJOUTERIE_AND_ACCESSORIES',
    SELLING_STATIONERY_SUPPLIES = 'SELLING_STATIONERY_SUPPLIES',
    AIR_TICKET_OFFICE = 'AIR_TICKET_OFFICE',
    SELLING_MOBILE_PHONES = 'SELLING_MOBILE_PHONES',
    SELLING_COSMETICS_AND_PERFUMERY = 'SELLING_COSMETICS_AND_PERFUMERY',
    SELLING_CHILDREN_CLOTHING = 'SELLING_CHILDREN_CLOTHING',
    SELLING_HOUSEHOLD_GOODS = 'SELLING_HOUSEHOLD_GOODS',
    PLANTS_SELLING = 'PLANTS_SELLING',
    SELLING_SUGAR_CHOCOLATE_AND_CONFECTIONERY = 'SELLING_SUGAR_CHOCOLATE_AND_CONFECTIONERY',
    FOOTWEAR_SELLING = 'FOOTWEAR_SELLING',
    BOOKS_SELLING = 'BOOKS_SELLING',
    GAMES_ROOM = 'GAMES_ROOM',
    KITCHENWARE_SELLING = 'KITCHENWARE_SELLING',
    CAR_SELLING = 'CAR_SELLING',
    SOUVENIR_MANUFACTURING = 'SOUVENIR_MANUFACTURING',
    COFFEE_HOUSE = 'COFFEE_HOUSE',
    FURNITURE_SELLING = 'FURNITURE_SELLING',
    SELLING_SILVER_AND_OTHER_METAL_JEWELLERY = 'SELLING_SILVER_AND_OTHER_METAL_JEWELLERY',
    CAFE = 'CAFE',
    BUSINESS_AND_MANAGEMENT_CONSULTING_SERVICES = 'BUSINESS_AND_MANAGEMENT_CONSULTING_SERVICES',
    MAIL_OR_INTERNET_SALES = 'MAIL_OR_INTERNET_SALES',
    CLINIC = 'CLINIC',
    CINEMA = 'CINEMA',
    SELLING_MEAT_AND_MEAT_PRODUCTS = 'SELLING_MEAT_AND_MEAT_PRODUCTS',
    SPORTS_HALL = 'SPORTS_HALL',
    SELLING_HUNTING_SUPPLIES = 'SELLING_HUNTING_SUPPLIES',
    SELLING_SWEETS = 'SELLING_SWEETS',
    TAILOR = 'TAILOR',
    SELLING_ELECTRICAL_HOUSEHOLD_GOODS = 'SELLING_ELECTRICAL_HOUSEHOLD_GOODS',
    CANTEEN = 'CANTEEN',
    SELLING_COMPUTERS = 'SELLING_COMPUTERS',
    STORAGE_AND_WAREHOUSING_SERVICES = 'STORAGE_AND_WAREHOUSING_SERVICES',
    ENTERTAINMENT_CENTER = 'ENTERTAINMENT_CENTER',
    PRODUCTION_OF_SAUSAGES = 'PRODUCTION_OF_SAUSAGES',
    LUMINAIRE_SELLING = 'LUMINAIRE_SELLING',
    CONFECTIONERY_PRODUCTION = 'CONFECTIONERY_PRODUCTION',
    SELLING_INDUSTRIAL_GOODS = 'SELLING_INDUSTRIAL_GOODS',
    SELLING_CONSTRUCTION_MATERIALS = 'SELLING_CONSTRUCTION_MATERIALS',
    TABLEWARE_SELLING = 'TABLEWARE_SELLING',
    SELLING_SPORTS_GOODS = 'SELLING_SPORTS_GOODS',
    SELLING_CHEMICALS = 'SELLING_CHEMICALS',
    SELLING_CAR_SPARE_PARTS = 'SELLING_CAR_SPARE_PARTS',
    SELLING_PHARMACEUTICAL_GOODS = 'SELLING_PHARMACEUTICAL_GOODS',
    FISH_RESTAURANT = 'FISH_RESTAURANT',
    JEWELLERY_SELLING = 'JEWELLERY_SELLING',
    RETAIL_TRADE_OF_FERTILIZERS_SEEDS_AND_PESTICIDES = 'RETAIL_TRADE_OF_FERTILIZERS_SEEDS_AND_PESTICIDES',
    GIFTS_SELLING = 'GIFTS_SELLING',
    WATCH_REPAIRING = 'WATCH_REPAIRING',
    SELLING_ANIMALS = 'SELLING_ANIMALS',
    BEER_HALL = 'BEER_HALL',
    CEREMONY_HOUSE = 'CEREMONY_HOUSE',
    SELLING_DAIRY_PRODUCTS = 'SELLING_DAIRY_PRODUCTS',
    SELLING_OPTICAL_GOODS = 'SELLING_OPTICAL_GOODS',
    TRANSLATION_SERVICES = 'TRANSLATION_SERVICES',
    BREAD_PRODUCTION = 'BREAD_PRODUCTION',
    PLASTICS_MANUFACTURING = 'PLASTICS_MANUFACTURING',
    HOTEL = 'HOTEL',
    SELLING_VETERINARY_GOODS = 'SELLING_VETERINARY_GOODS',
    PIZZA_SHOP = 'PIZZA_SHOP',
    SELLING_ANIMAL_FEED = 'SELLING_ANIMAL_FEED',
    MOTEL = 'MOTEL',
    DENTAL_CLINIC = 'DENTAL_CLINIC',
    SELLING_CERAMICS_TILES = 'SELLING_CERAMICS_TILES',
    PRODUCTION_OF_PLASTIC_DOORS_AND_WINDOWS = 'PRODUCTION_OF_PLASTIC_DOORS_AND_WINDOWS',
    WOMEN_BEAUTY_SALON = 'WOMEN_BEAUTY_SALON',
    SELLING_CURTAINS = 'SELLING_CURTAINS',
    PRODUCTION_OF_OTHER_MACHINERY_AND_TOOLS = 'PRODUCTION_OF_OTHER_MACHINERY_AND_TOOLS',
    PUBLIC_ADMINISTRATIVE_BUILDING = 'PUBLIC_ADMINISTRATIVE_BUILDING',
    TOUR_OPERATOR = 'TOUR_OPERATOR',
    DENTAL_OFFICE = 'DENTAL_OFFICE',
    PRODUCTION_OF_ALCOHOLIC_BEVERAGES = 'PRODUCTION_OF_ALCOHOLIC_BEVERAGES',
    SELLING_HEATING_SYSTEMS = 'SELLING_HEATING_SYSTEMS',
    REFRACTORY_MATERIALS_MANUFACTURING = 'REFRACTORY_MATERIALS_MANUFACTURING',
    DRY_CLEANING_SERVICES = 'DRY_CLEANING_SERVICES',
    GROWING_OTHER_PLANTS = 'GROWING_OTHER_PLANTS',
    SELLING_TEXTILE_MATERIALS = 'SELLING_TEXTILE_MATERIALS',
    SELLING_FLOUR_AND_FLOUR_PRODUCTS = 'SELLING_FLOUR_AND_FLOUR_PRODUCTS',
    PRODUCTION_OF_RUBBER_TYRES_TUBES_AND_PIPES = 'PRODUCTION_OF_RUBBER_TYRES_TUBES_AND_PIPES',
    PRODUCTION_OF_OTHER_CONCRETE_PRODUCTS = 'PRODUCTION_OF_OTHER_CONCRETE_PRODUCTS',
    SOUVENIRS_SELLING = 'SOUVENIRS_SELLING',
    BAGS_SELLING = 'BAGS_SELLING',
    BAR = 'BAR',
    MEN_BARBER_SHOP = 'MEN_BARBER_SHOP',
    SHOPPING_CENTER = 'SHOPPING_CENTER',
    FASHION_HOUSE_ATELIER = 'FASHION_HOUSE_ATELIER',
    PLUMBING_EQUIPMENT_INSTALLATION_SERVICES = 'PLUMBING_EQUIPMENT_INSTALLATION_SERVICES',
    SELLING_STYROFOAM = 'SELLING_STYROFOAM',
    POULTRY_FARMING = 'POULTRY_FARMING',
    PRODUCTION_OF_MILK_AND_DAIRY_PRODUCTS = 'PRODUCTION_OF_MILK_AND_DAIRY_PRODUCTS',
    PHONE_REPAIR = 'PHONE_REPAIR',
    SELLING_EQUIPMENT_FOR_MINING_AND_CONSTRUCTION = 'SELLING_EQUIPMENT_FOR_MINING_AND_CONSTRUCTION',
    TEAHOUSE = 'TEAHOUSE',
    TOYS_SELLING = 'TOYS_SELLING',
    MANUFACTURING_OF_OTHER_FINISHED_METAL_PRODUCTS = 'MANUFACTURING_OF_OTHER_FINISHED_METAL_PRODUCTS',
    PET_SHOP = 'PET_SHOP',
    ADVERTISING_SERVICE = 'ADVERTISING_SERVICE',
    POLYCLINIC = 'POLYCLINIC',
    MANUFACTURING_OF_OTHER_FOOD_PRODUCTS = 'MANUFACTURING_OF_OTHER_FOOD_PRODUCTS',
    SELLING_SCHOOL_SUPPLIES = 'SELLING_SCHOOL_SUPPLIES',
    PARK = 'PARK',
    TOUR_AGENT = 'TOUR_AGENT',
    SELLING_OTHER_MACHINES_AND_EQUIPMENT = 'SELLING_OTHER_MACHINES_AND_EQUIPMENT',
    SELLING_AGRICULTURAL_MACHINES_AND_EQUIPMENT = 'SELLING_AGRICULTURAL_MACHINES_AND_EQUIPMENT',
    PRODUCTION_OF_OTHER_NON_FOOD_PRODUCTS = 'PRODUCTION_OF_OTHER_NON_FOOD_PRODUCTS',
    PRODUCTION_OF_FLOUR_MILLING_INDUSTRY_PRODUCTS = 'PRODUCTION_OF_FLOUR_MILLING_INDUSTRY_PRODUCTS',
    PRODUCTION_OF_MEN_CLOTHING = 'PRODUCTION_OF_MEN_CLOTHING',
    PRODUCTION_OF_COMBI_RADIATORS = 'PRODUCTION_OF_COMBI_RADIATORS',
    CATERING_SERVICE = 'CATERING_SERVICE',
    SELLING_ROOF_COVERINGS = 'SELLING_ROOF_COVERINGS',
    BEACH = 'BEACH',
    TANDOOR_OVEN = 'TANDOOR_OVEN',
    REPAIR_OF_OTHER_PRODUCTS_EQUIPMENT_AIRCRAFTS = 'REPAIR_OF_OTHER_PRODUCTS_EQUIPMENT_AIRCRAFTS',
    SELLING_SANITARY_GOODS = 'SELLING_SANITARY_GOODS',
    FLOUR_PRODUCTION = 'FLOUR_PRODUCTION',
    SELLING_MEDICAL_AND_ORTHOPAEDIC_GOODS = 'SELLING_MEDICAL_AND_ORTHOPAEDIC_GOODS',
    SPA_SALON = 'SPA_SALON',
    HAZELNUT_PROCESSING = 'HAZELNUT_PROCESSING',
    GYM_FITNESS_HALL = 'GYM_FITNESS_HALL',
    NEWSPAPER_STAND = 'NEWSPAPER_STAND',
    FOOTBALL_FIELD = 'FOOTBALL_FIELD',
    SELLING_OTHER_PHONES = 'SELLING_OTHER_PHONES',
    PRODUCTION_OF_PILLOWS_MATTRESSES = 'PRODUCTION_OF_PILLOWS_MATTRESSES',
    PRODUCTION_OF_PLASTIC_BAGS = 'PRODUCTION_OF_PLASTIC_BAGS',
    PRODUCTION_OF_CHEMICAL_PRODUCTS = 'PRODUCTION_OF_CHEMICAL_PRODUCTS',
    LIMESTONE_AND_GYPSUM_MINING = 'LIMESTONE_AND_GYPSUM_MINING',
    SELLING_FLOWERS = 'SELLING_FLOWERS',
    PRODUCTION_OF_MARBLE = 'PRODUCTION_OF_MARBLE',
    PRODUCTION_OF_PACKAGING_FROM_OTHER_MATERIALS = 'PRODUCTION_OF_PACKAGING_FROM_OTHER_MATERIALS',
    CARPETS_SELLING = 'CARPETS_SELLING',
    SELLING_AUDIO_AND_VIDEO_EQUIPMENT = 'SELLING_AUDIO_AND_VIDEO_EQUIPMENT',
    INSTALLATION_ELECTRIC_HEATING_SYSTEMS = 'INSTALLATION_ELECTRIC_HEATING_SYSTEMS',
    SELLING_TELECOMMUNICATION_EQUIPMENT = 'SELLING_TELECOMMUNICATION_EQUIPMENT',
    GLASS_SELLING = 'GLASS_SELLING',
    FODDER_PRODUCTION = 'FODDER_PRODUCTION',
}
